import React, { useState } from "react";
import { createAmazonSellerAccount } from "../API/amazon";
import { useSnackbarContext } from "../../contexts/Snackbar";
import { createAmazonUrl } from "./util";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Formik, Form } from "formik";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import * as yup from "yup";
import Submit from "../modals/SubmitButtonFormikDialog";

const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: 450,
  },
  field: {
    width: 400,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  successMessage: { display: "flex" },
  successIcon: {
    color: theme.palette.status.active,
    marginRight: theme.spacing(0.5),
  },
}));

export default function ConnectAmazonForm(props) {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const [success, setSuccess] = useState(false);
  const { handleClose, lines = null } = props;

  return (
    <Formik
      initialValues={{ name: "" }}
      validationSchema={yup.object({
        name: yup.string().required("Required"),
      })}
      onSubmit={async (values) => {
        try {
          const response = await createAmazonSellerAccount(values.name);
          setSuccess(true);
          const { id } = await response.json();
          setTimeout(() => {
            window.open(createAmazonUrl(id, lines));
            handleClose();
          }, 750);
        } catch (error) {
          snackbar.show(
            "Oops, we encountered an issue while connecting to Amazon Seller Central. Please try again.",
            "error"
          );
        }
      }}
      component={({ submitForm, isSubmitting }) => {
        return (
          <React.Fragment>
            <DialogContent dividers className={classes.dialogContent}>
              <Form>
                <div>
                  <DialogContentText>
                    Once you click connect, we'll redirect you to Amazon Seller
                    Central to finish connecting to your account.
                  </DialogContentText>
                  <Field
                    component={TextField}
                    name="name"
                    label="Account Nickname"
                    variant="outlined"
                    className={classes.field}
                  />
                </div>
              </Form>
              {success && (
                <div className={classes.successMessage}>
                  <CheckCircleIcon className={classes.successIcon} />
                  <span>
                    Success. You'll be redirected to Amazon Seller Central in
                    just a few moments.
                  </span>
                </div>
              )}
            </DialogContent>
            <Submit
              submitForm={submitForm}
              isSubmitting={isSubmitting}
              handleClose={handleClose}
              text="Connect"
              disabled={success}
            />
          </React.Fragment>
        );
      }}
    />
  );
}
